<h2 mat-dialog-title>
  <mat-icon class="fa fa-calculator"></mat-icon>
  Edit Buyer Formula
</h2>

<div mat-dialog-content>
  @if (usda$ | async; as usda) {
    @if (usda.visible) {
      <tc-usda-proposal-panel
        [entry]="dealLine?.entry ?? null" [evaluated]="!!dealLine" [preview]="usda.preview"
        [currency]="currency" [unit]="measureId" [formula]="currentFormula"
        (useProposedPrice)="useProposedPrice($event)"
      ></tc-usda-proposal-panel>
    }
  }
  <tc-formula-form
    [formula]="formula"
    [currency]="currency"
    [measureId]="measureId"
    [defaultIncoterm]="defaultIncoterm"
    [defaultLocation]="defaultLocation"
    [paymentTermsDates]="paymentTermsDates"
    [accountId]="buyerId"
    [productName]="productName"
    [showAddRemoveLines]="false"
    [isWithIndexPrice]="true"
    [indexPrice]="indexPrice"
    [readonlyFields]="readonlyFields"
    (formulaChange)="onFormulaChange($event)"
    (validityChange)="onValidityChange($event)"
    (flatPriceChange)="onFlatPriceChange($event)"
  ></tc-formula-form>
</div>

<div mat-dialog-actions align="end">
  <button mat-button type="button" (click)="cancel()">Cancel</button>
  <button mat-raised-button type="button" color="primary" [disabled]="!(isValid$ | async)" (click)="save()">
    <i class="fa fa-fw fa-check" aria-hidden="true"></i>
    Apply Formula
  </button>
</div>
